import { useNavigate } from "react-router-dom";
import Header from "../layout/header";

function ActionCard({ title, description, onClick, icon }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        width: "100%",
        backgroundColor: "#20232b",
        border: "1px solid #3a3f4b",
        borderRadius: "14px",
        padding: "24px",
        color: "#fff",
        textAlign: "left",
        cursor: "pointer",
        transition: "all 0.2s ease"
      }}
      onMouseEnter={(event) => {
        event.currentTarget.style.transform = "translateY(-3px)";
        event.currentTarget.style.borderColor = "#166534";
        event.currentTarget.style.boxShadow = "0 10px 24px rgba(0, 0, 0, 0.25)";
      }}
      onMouseLeave={(event) => {
        event.currentTarget.style.transform = "translateY(0)";
        event.currentTarget.style.borderColor = "#3a3f4b";
        event.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          marginBottom: "10px"
        }}
      >
        <span>{icon}</span>
        <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700 }}>{title}</h2>
      </div>
      <p style={{ margin: 0, color: "#9ca3af", fontSize: "14px" }}>{description}</p>
    </button>
  );
}

function OnboardingProcessPage() {
  const navigate = useNavigate();

  return (
    <div className="main">
      <Header />
      <div
        style={{
          padding: "clamp(16px, 3vw, 24px) clamp(12px, 3vw, 24px)",
          maxWidth: "100%",
          boxSizing: "border-box",
          minHeight: "calc(100vh - 80px)",
          background: "linear-gradient(135deg, #1e2127 0%, #2a2d35 100%)"
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <h1 style={{ margin: "0 0 8px 0", color: "#fff" }}>Onboarding Process</h1>
          <p style={{ margin: 0, color: "#9ca3af" }}>
            Select one of the onboarding modules to continue.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 240px), 1fr))",
            gap: "16px",
            maxWidth: "840px"
          }}
        >
          <ActionCard
            title="Onboarding Objects"
            description="Open onboarding object module and manage related details."
            onClick={() => navigate("/onboarding-object")}
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <path d="M9 9h6v6H9z"></path>
              </svg>
            }
          />

          <ActionCard
            title="Onboarding Status"
            description="Track and update onboarding completion status client-wise using dropdown selection."
            onClick={() => navigate("/onboarding-status")}
            icon={
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 11l3 3L22 4"></path>
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
              </svg>
            }
          />
        </div>
      </div>
    </div>
  );
}

export default OnboardingProcessPage;
